<template>
     <v-container fluid>
         <v-card>
            <v-toolbar>
                <v-icon>cloud_download</v-icon>
                <v-toolbar-title class="font-weight-light">&nbsp;Importación Padrón Ingresos Bruto</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn text icon color="red" v-on="on" @click="setStatusTareaFrecuente(action)">
                    <v-icon v-if="action.esFrecuente">favorite</v-icon>
                    <v-icon v-else>favorite_border</v-icon>
                    </v-btn>
                </template>
                <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>  
                <span v-else>Agregar a Tareas Frecuentes</span>  
                </v-tooltip>
            </v-toolbar>
            <v-card-text>
                <span class="title" >Filtros</span>
                <v-divider></v-divider>
                <v-row dense>
                    <v-col cols="6" lg="3">
                    <v-autocomplete v-model="provinciaId" :items="provincias" 
                    item-text="nombre" item-value="id" label="Provincia" placeholder="Seleccione una provincia" :menu-props="{minWidth:'400'}"></v-autocomplete>
                      </v-col> 

                    <v-col cols="2" >
                       <v-text-field v-model="fecha" label="Fecha" type="date" prepend-icon="event"></v-text-field>
                    </v-col> 
                     <v-col cols="6" lg="3">
                     <!--   <v-file-input  
                            v-model="archivoFiltroOperaciones"
                            placeholder="Seleccione el archivo"
                            label="Archivo Filtro"
                            prepend-icon="mdi-paperclip">
                        </v-file-input>-->
                        <v-file-input
                            v-model="archivoFiltroOperaciones"
                            @change="onFileChange" 
                            placeholder="Seleccione el archivo"
                            label="Archivo Filtro"
                            prepend-icon="mdi-paperclip"
                            ></v-file-input>
                    </v-col>

                </v-row>

            </v-card-text>
            <v-card-actions>
             
                <v-spacer></v-spacer>
                
                  <v-btn dark  color="green" @click="procesar">
                    Procesar&nbsp;              
                </v-btn>
            </v-card-actions>

         </v-card>

        <app-loading :loading="loading"></app-loading>

     </v-container>
</template>
<script>

import { http } from '@/axios'
import Vue from 'vue'
import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

export default {
    data() {
        return {
            loading: false,
            modeloId: 4,
            provinciaId: 0,
            fecha: null,
            provincias:[],
            archivoFiltroOperaciones : null,
        }
    },
    async created() {
      this.loadProvincias();
      this.fecha = this.$moment().startOf('month').format('YYYY-MM-DD');

    }, 
    computed: {
        ...mapGetters(['activeTask','getActionFromLink','user','closeRelatedTasks']),
        action: function(){
        return this.getActionFromLink(this.$route.path) 
        },
    },
  methods: {
    ...mapMutations(["setActiveTask","alertClear", "alertSuccess", "alertWarning", "alertError","setReporteActivo"]),
    ...mapActions(['setStatusTareaFrecuente']),    
    

    
    validar(){
        if(this.provinciaId === 0) 
        {
            this.alertWarning('Debe seleccionar una Provincia.');
            return false;
        }

        if(this.archivoFiltroOperaciones === null) 
        {
            this.alertWarning('Debe seleccionar un archivo.');
            return false;
        }

        return true;
    },

        async procesar() {
    if (!this.validar()) {
        return;
    }

    this.loading = true;

    const formData = new FormData();

    formData.append('file', this.archivoFiltroOperaciones);
    formData.append('provinciaId', this.provinciaId);
    formData.append('fechaPublicacion', this.fecha);

   try {
         /*console.log('Datos enviados al backend:', {
                file: this.archivoFiltroOperaciones,
                provinciaId: this.provinciaId,
                fechaPublicacion: this.fecha
                });*/
        const response = await http.post('fileProcessing/procesarPadronIibb', formData);
        if (response.success) {
        this.alertSuccess('Padrón de Ingresos Brutos importado correctamente.');
        } else {
        this.alertError('Error al importar el Padrón de Ingresos Bruto.');
        }
    } catch (error) {
        Vue.$log.error(error);
        this.alertError('Error al importar el Padrón de Ingresos Bruto.');
    }

    this.loading = false;
    },

    onFileChange(event) {
      // Este método se llama cuando el usuario selecciona un archivo
      this.archivoFiltroOperaciones = event; // Asigna el archivo seleccionado a la propiedad this.archivoFiltroOperaciones
    },

    async loadProvincias(){
        this.loading = true
        try {
            var result = await http.get('provincias'); // traigo todas
            this.provincias = result.list;
        } catch (error) {
            // Error
            Vue.$log.error(error);
        }
        this.loading = false
      }
},
  
}
</script>